module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-152x152-2839f150e94dd93535aabe359fa920ad.png";